import type { ApolloClient } from '@apollo/client'
import { type RefType } from 'src/services/apollo/generated/graphql'
import {
  executeDeleteMessage,
  executeSendMessageV2,
} from 'src/services/apollo/message'

/**
 * The optional `apolloClient` argument lets callers pin the mutation to a
 * route-scoped Apollo client (returned by `useApolloClient()` inside an
 * `<ApolloProvider client={routeClient}>` subtree). See the long comment
 * on `createMutationHelper` in `services/apollo/utils.ts` — without this,
 * detail pages mounting their own route-scoped Apollo client end up
 * shipping a comment that doesn't appear until page reload because the
 * `update(cache, …)` callback writes into the wrong (base) cache.
 */

export async function sendMessage(
  topicId: string,
  topicRefType: RefType,
  content: string,
  replyToMessageId?: string,
  headers?: Record<string, string>,
  apolloClient?: ApolloClient,
) {
  content = content.trim()
  if (!content) return
  const res = await executeSendMessageV2(
    {
      topicId,
      topicRefType,
      input: {
        type: 'TEXT',
        content,
        replyToMessageId,
      },
    },
    headers && Object.keys(headers).length > 0
      ? { context: { headers } }
      : undefined,
    apolloClient,
  )
  return res.data?.sendMessageV2
}

export async function deleteMessage(
  messageId: string,
  topicRefType: RefType,
  apolloClient?: ApolloClient,
) {
  await executeDeleteMessage(
    {
      messageId,
      topicRefType,
    },
    undefined,
    apolloClient,
  )
}
